export const UI_MODAL_OPEN = '@UI_MODAL_OPEN'
export const UI_MODAL_CLOSE = '@UI_MODAL_CLOSE'
export const UI_MODAL_CLEAR_PROPS = '@UI_MODAL_CLEAR_PROPS'

export default {
  UI_MODAL_OPEN,
  UI_MODAL_CLOSE,
  UI_MODAL_CLEAR_PROPS
}
